import type SearchScenarioId from "../store/schema/SearchScenarioId";
import getScenarioStore from "./getScenarioStore";

export default function isSearchHitHighlightingEnabled(scenarioId: SearchScenarioId): boolean {
    return getScenarioStore(scenarioId).isHitHighlightingEnabled;
}
